import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "@splidejs/react-splide/css";
import "./index.css";
import "./App.css";
import "assets/css/comfortaa.css";
import "assets/css/sarabun.css";
import "./tailwind.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { StyledEngineProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store/configureStore";
import socketService from "./services/socketService";
import { env } from "./env";

const SOCKET_URL = env.REACT_APP_SOCKET_URL;
socketService.connect(SOCKET_URL);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename="/">
        <StyledEngineProvider injectFirst>
          <App />
        </StyledEngineProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

window.addEventListener("beforeunload", () => {
  socketService.disconnect();
});

reportWebVitals();
